import React, { useEffect, useState, useContext } from "react";
import ReactGA from "react-ga4";
import { CurrentUser } from "../../business/helper/CurrentUser";
const TRACKING_ID = `${process.env.REACT_APP_CURRENT_GOOGLEGA4_ID}`;

export function GrtAnalyticsGA4({ onLoaded }) {
  const [analytics, setAnalytics] = useState(null);
  useEffect(() => {
    if (analytics) {
      onLoaded(analytics);
    }
  }, [analytics]);

  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
    let ctx = {};

    ctx.trackPageAnalytics = (hitType, page, title) => {
      ReactGA.send({ hitType: hitType, page: page, title: title });
    };

    ctx.trackEventAnalytics = (category, action, label) => {
      ReactGA.event({
        category: category,
        action: action,
        label: label,
      });
    };

    var userProfile = CurrentUser.GetCurrentUserData();

    if (userProfile) {
      let user = userProfile;
      let userInfo =
        "FirstName: " +
        user.firstName?.trim() +
        " / LastName:" +
        user.lastName?.trim() +
        " / OuId:" +
        (user.ouId ? user.ouId : "NA") +
        " / UserId:" +
        (user.userId ? user.userId : "NA");

      let visitorType =
        user && user.isManager
          ? "Manager"
          : user.userType
            ? user.userType
            : "Driver";

      ReactGA.gtag("config", TRACKING_ID, {
        user_id: userInfo,
      });
      ReactGA.gtag("js", new Date());
      ReactGA.gtag("set", "user_properties", {
        user_id: userInfo,
        Ou: user.ouId,
        Name: user?.firstName?.trim() + " " + user?.lastName?.trim(),
        VisitorType: visitorType,
        Visitor: user.userId,
      });

      ReactGA.gtag("config", TRACKING_ID);

      ReactGA.gtag("config", TRACKING_ID, {
        linker: { accept_incoming: true },
        site_speed_sample_rate: 100,
      });

      ReactGA.gtag("config", TRACKING_ID, {
        cookie_domain: "none",
      });
      setAnalytics(ctx);
    }
  }, []);

  return <></>;
}
